import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import MenuSelectForm from "./MenuSelectForm"

const makeRemainTypes = (types, menus) => {
	return types.filter(type =>
		type.isDefault === 1 &&
    type.id < 7 &&
    type.id !== 3 &&
    type.id !== 4 &&
    menus.filter(menu => menu.typeId === type.id).length === 0
	)
}

const makeDefaultType = (remainTypes) => {
	return remainTypes && remainTypes.length > 0 ? remainTypes[0] : null
}

export default function DefaultMenuDetailForm({onChange, onFocus, onBlur}) {
  const types = useSelector(state => state.blogmenu.types)
  const menus = useSelector(state => state.blogmenu.menus)

  const [remainTypes, setRemainTypes] = useState(makeRemainTypes(types, menus))
  const [selectedType, setSelectedType] = useState(makeDefaultType(remainTypes))

  function handleSelect(item) {
    setSelectedType(types.find(type => type.id === item.value))
    onChange(item.value, '')
  }

  useEffect(() => {
    setRemainTypes(makeRemainTypes(types, menus))
  }, [types, menus])

  useEffect(() => {
    const defaultType = makeDefaultType(remainTypes)
    setSelectedType(defaultType)
    onChange(defaultType? defaultType.id : null, '')
  }, [remainTypes])

  useEffect(() => {
    onChange(selectedType? selectedType.id : null, '')
  }, [])

  if (remainTypes.length === 0) {
    return (
      <span className="lab_menu">모두 표시 중입니다.</span>
    )
  }

  return (
    <MenuSelectForm className="opt_menu opt_menu2" items={
      remainTypes.map(item => ({ label:item.name, value:item.id }))
    } selected={selectedType.id} onSelect={handleSelect}/>
  )
}
